import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import InternetComplementaryProductBlockData from 'app/Models/Content/InternetComplementaryProductBlockData';
import React from 'react';
import MarketingTextBlockData from 'Models/Content/MarketingTextBlockData';
import IconBlockData from 'Models/Content/IconBlockData';
import {getTextWithHighlight} from 'app/utilities/highlightText';
import {getImageProps} from 'app/utilities/ImageProps';
import {Container, Col} from 'reactstrap';

const InternetComplementaryProductBlock = ({data, context}: ComponentProps<InternetComplementaryProductBlockData>) => {
  const checkIfCommaOrDot = (price) => {
    if (price.indexOf('.') > -1) {
      return (
        <span className='splitted-value'>
          {price.split('.')[0]} <span className='small-price'>.{price.split('.')[1]}</span>
        </span>
      );
    } else {
      return price;
    }
  };

  return (
    <Container>
      <a href={data.buttonLink.value} className='InternetComplementaryProductBlock'>
        <div className='InternetComplementaryProductBlock__price-and-iconsBlock'>
          <div className='InternetComplementaryProductBlock__price-and-iconsBlock__icons'>
            {data.icons.expandedValue.map(({description, image}: IconBlockData, i) => (
              <span className='InternetComplementaryProductBlock__price-and-iconsBlock__icons__image-and-description' key={i}>
                <Image {...getImageProps(image, context)} src={context.getEpiserverUrl(image.expandedValue.url)} alt='' />

                <span className='InternetComplementaryProductBlock__price-and-iconsBlock__icons__image-and-description__description'>
                  {description.value}
                </span>
              </span>
            ))}
          </div>

          <div className='InternetComplementaryProductBlock__price-and-iconsBlock__price-note-value'>
            <span className='InternetComplementaryProductBlock__price-and-iconsBlock__price-note-value__price'>
              <span className='InternetComplementaryProductBlock__price-and-iconsBlock__price-note-value__price__value'>
                <span className='InternetComplementaryProductBlock__price-and-iconsBlock__price-note-value__price__value__ils'>₪</span>
                {checkIfCommaOrDot(data.price.value)}
              </span>

              <span className='InternetComplementaryProductBlock__price-and-iconsBlock__price-note-value__price__label-note'>
                <span className='InternetComplementaryProductBlock__price-and-iconsBlock__price-note-value__price__label-note__label'>
                  {data.priceLabel.value}
                </span>
                <span className='InternetComplementaryProductBlock__price-and-iconsBlock__price-note-value__price__label-note__note'>
                  {data.note.value}
                </span>
              </span>
            </span>
          </div>
        </div>

        <Image className='InternetComplementaryProductBlock__image' {...getImageProps(data.image, context)} />

        <div className='InternetComplementaryProductBlock__title-subtitle-button'>
          {data.title.expandedValue.map(({text, highlightText}: MarketingTextBlockData, i) => (
            <h2 key={i}>{getTextWithHighlight({text: text.value, highlightText: highlightText.value})}</h2>
          ))}

          <span className='InternetComplementaryProductBlock__title-subtitle-button__subtitle'>{data.subtitle.value}</span>

          <div className='InternetComplementaryProductBlock__title-subtitle-button__button'>{data.buttonLinkTitle.value}</div>
        </div>
      </a>
    </Container>
  );
};

export default InternetComplementaryProductBlock;
